import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import {
  useStripe,
  useElements,
  PaymentElement,
  AddressElement,
  ExpressCheckoutElement
} from '@stripe/react-stripe-js';
import { ActivityIndicator, Image, View, Text, TouchableOpacity } from "react-native";
import Button from "./../../../../../components/button/Button";
import { useIsFocused } from '@react-navigation/native';
import ajax from '../../../../../helpers/ajaxHelper';
import Urls from '../../../../../services/Urls';
import getPlatformType from '../../../../../helpers/helpers';
import Colors from '../../../../../constants/Colors';

export const CheckoutForm = (props) => {
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();

  const [user, setUser] = useState({});
  const [loader, setLoader] = useState(false);

  const focused = useIsFocused();
  const layoutType = getPlatformType();

  const userDetails = useSelector(
    (state) => state?.Login?.userDetails
  );

  useEffect(() => {
    ajax
      .get(Urls.PROFILE)
      .then(({ data }) => {
        if (data?.status) {
          setUser(data?.data.userDetails);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, [focused]);

  const handleExpressConfirm = async (event) => {
    setLoader(true);

    if (!stripe || !elements) {
      setLoader(false);
      return;
    }

    try {
      dispatch({ type: "tenantConstants.MAKE_PAYMENTS" });

      const returnUrl =
        typeof window !== "undefined" && window.location
          ? window.location.href
          : "https://hubita.co.uk";

      const response = await stripe.confirmPayment({
        elements,
        redirect: "if_required",
        confirmParams: {
          return_url: returnUrl,
        },
      });

      console.log("express checkout response", response);

      setLoader(false);

      switch (response?.paymentIntent?.status) {
        case "succeeded":
        case "processing":
          props.onSuccessToken(true);
          break;

        case "requires_payment_method":
        default:
          props.onSuccessToken(false);
          break;
      }

      dispatch({
        type: "tenantConstants.MAKE_PAYMENTSSUCCESS",
      });
    } catch (error) {
      setLoader(false);
      console.log("express checkout error", error);

      dispatch({
        type: "tenantConstants.MAKE_PAYMENTSSUCCESS",
      });

      props.onSuccessToken(false);
    }
  };

  const handleSubmit = async (event) => {
    if (event && typeof event.preventDefault === "function") {
      event.preventDefault();
    }

    setLoader(true);

    if (!stripe || !elements) {
      setLoader(false);
      return;
    }

    try {
      dispatch({ type: "tenantConstants.MAKE_PAYMENTS" });

      const addressElement = elements.getElement("address");
      const address = await addressElement?.getValue();

      console.log({
        shipping: address?.value,
      });

      const returnUrl =
        typeof window !== "undefined" && window.location
          ? window.location.href
          : "https://hubita.co.uk";

      const response = await stripe.confirmPayment({
        elements,
        redirect: "if_required",
        confirmParams: {
          return_url: returnUrl,
          shipping: address?.value,
        },
      });

      console.log("response", response);

      setLoader(false);

      switch (response?.paymentIntent?.status) {
        case "succeeded":
        case "processing":
          props.onSuccessToken(true);
          break;

        case "requires_payment_method":
        default:
          props.onSuccessToken(false);
          break;
      }

      dispatch({
        type: "tenantConstants.MAKE_PAYMENTSSUCCESS",
      });
    } catch (error) {
      setLoader(false);
      console.log(error);

      dispatch({
        type: "tenantConstants.MAKE_PAYMENTSSUCCESS",
      });

      props.onSuccessToken(false);
    }
  };

  return (
    <View style={{ width: "100%" }}>
      <View style={{ marginBottom: 15 }}>
        <ExpressCheckoutElement
          onConfirm={handleExpressConfirm}
          options={{
            paymentMethods: {
              googlePay: "always",
              applePay: "auto",
            },
          }}
        />
      </View>

      <form onSubmit={handleSubmit}>

        {/* Existing card form */}
        <PaymentElement
          options={{
            defaultValues: {
              billingDetails: {
                email: userDetails?.email,
                name:
                  userDetails?.first_name +
                  " " +
                  userDetails?.last_name,
                phone:
                  userDetails?.contact_number
                    ? userDetails?.contact_number
                    : "",
              }
            }
          }}
        />

        {/* Address form */}
        <AddressElement
          options={{
            mode: "billing",
            allowedCountries: ["GB"],
            blockPoBox: true,
            defaultValues: {
              name: user?.first_name
                ? user?.first_name + " " + user?.last_name
                : "",
              address: {
                country: "GB",
              },
            },
            fields: {
              phone: "always",
            },
            validation: {
              phone: {
                required: "never",
              },
            },
          }}
        />

        <View
          style={{
            marginTop: 24,
            width: "100%",
            flexDirection: "row",
            gap: 12,
            alignItems: "center",
          }}
        >
          <TouchableOpacity
            style={{
              flex: 1,
              height: 44,
              backgroundColor: "#F1F5F9",
              borderRadius: 10,
              alignItems: "center",
              justifyContent: "center",
              borderWidth: 1,
              borderColor: "#E2E8F0",
              cursor: "pointer",
            }}
            onPress={() => (props?.onCancel ? props.onCancel() : null)}
            activeOpacity={0.8}
          >
            <Text style={{ fontSize: 14, fontWeight: "600", color: "#475569" }}>
              Cancel
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={{
              flex: 1.5,
              height: 44,
              backgroundColor: loader ? "#9CA3AF" : "#6C2BD9",
              borderRadius: 10,
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "row",
              gap: 8,
              cursor: loader ? "not-allowed" : "pointer",
              boxShadow: "0 4px 6px -1px rgba(108, 43, 217, 0.2)",
            }}
            disabled={loader}
            onPress={handleSubmit}
            activeOpacity={0.85}
          >
            {loader ? (
              <ActivityIndicator color={"#FFFFFF"} size="small" />
            ) : (
              <Text style={{ fontSize: 14, fontWeight: "700", color: "#FFFFFF" }}>
                {props?.totalAmount ? `Pay £${props.totalAmount}` : "Confirm Payment"}
              </Text>
            )}
          </TouchableOpacity>
        </View>

        <View style={{ marginTop: 16, alignItems: 'center', justifyContent: 'center' }}>
          <Image
            source={require("./../../../../../assets/images/stripe.png")}
            resizeMode="contain"
            style={{
              height: 20,
              width: 100,
              opacity: 0.8,
            }}
          />
        </View>
      </form>
    </View>
  );
};

export default CheckoutForm;